import HOC from '../HOC';
import {reddit} from '../utility';

let Reddit = () => {return null;}

export default HOC(Reddit, reddit);



// WEBPACK FOOTER //
// ./src/components/News/Reddits.js